/**
 * @generated SignedSource<<89ff2154c0a904565d89c5355eaa7cb7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resellerPlId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "revenuePeriod",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "revenueMin",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "incentivePerc",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ResellerProgramLineUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateResellerProgramLineTPayload",
        "kind": "LinkedField",
        "name": "updateResellerProgramLineTByResellerPlId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ResellerProgramLineT",
            "kind": "LinkedField",
            "name": "resellerProgramLineT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ResellerProgramLineUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateResellerProgramLineTPayload",
        "kind": "LinkedField",
        "name": "updateResellerProgramLineTByResellerPlId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ResellerProgramLineT",
            "kind": "LinkedField",
            "name": "resellerProgramLineT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b041cbe3a1c510f733f331c6b4fd17f2",
    "id": null,
    "metadata": {},
    "name": "ResellerProgramLineUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation ResellerProgramLineUpdateMutation(\n  $input: UpdateResellerProgramLineTByResellerPlIdInput!\n) {\n  updateResellerProgramLineTByResellerPlId(input: $input) {\n    resellerProgramLineT {\n      resellerPlId\n      revenuePeriod\n      revenueMin\n      incentivePerc\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "c594baf48d71d8b46948ef1e17729303";

module.exports = node;
